import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import InstallPrompt from "./components/InstallPrompt";
import UpdateNotification from "./components/UpdateNotification";
import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import ChatPage from "./pages/ChatPage";
import ImageGenPage from "./pages/ImageGenPage";
import VideoGenPage from "./pages/VideoGenPage";
import SpeechToTextPage from "./pages/SpeechToTextPage";
import SummarizePage from "./pages/SummarizePage";
import SettingsPage from "./pages/SettingsPage";
import SharedImagePage from "./pages/SharedImagePage";
import AssistantsPage from "./pages/AssistantsPage";
import HistoryPage from "./pages/HistoryPage";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute, { AuthProvider } from "./components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  
  // Check for session_id in URL fragment (from Google Auth callback)
  // This must be checked synchronously during render, NOT in useEffect
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      
      {/* Protected routes */}
      <Route element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/chat/:sessionId" element={<ChatPage />} />
        <Route path="/assistants" element={<AssistantsPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/image" element={<ImageGenPage />} />
        <Route path="/video" element={<VideoGenPage />} />
        <Route path="/speech" element={<SpeechToTextPage />} />
        <Route path="/summarize" element={<SummarizePage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            {/* Public shared image route - outside AuthProvider */}
            <Route path="/shared/:shareId" element={<SharedImagePage />} />
            
            {/* All other routes need AuthProvider */}
            <Route path="/*" element={
              <AuthProvider>
                <AppRouter />
              </AuthProvider>
            } />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        <InstallPrompt />
        <UpdateNotification />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
